import SpinViewer from "./SpinViewer";
import SpriteImage from "./SpriteImage";
import { VERSION } from "../version";

export default {
  SpinViewer,
  SpriteImage,
  VERSION,
}
